import React from 'react';
import SectionTitle from './common/SectionTitle';
import FeatureCard from './common/FeatureCard';
import { FaBoxes, FaRoute, FaMobileAlt, FaChartLine, FaStore, FaClipboardCheck } from 'react-icons/fa';

const Features = () => {
  const features = [
    {
      icon: <FaBoxes />,
      title: "Distributor Management System",
      description: "Web-based platform to manage inventory, orders, and distribution operations"
    },
    {
      icon: <FaMobileAlt />,
      title: "Mobile Sales Point",
      description: "Android app for sales reps to take orders and process payments in the field"
    },
    {
      icon: <FaRoute />,
      title: "Route Optimization",
      description: "AI-powered route planning to maximize sales visits and minimize travel time"
    },
    {
      icon: <FaChartLine />,
      title: "Real-time Analytics",
      description: "Dashboard with key metrics and performance indicators for your business"
    },
    {
      icon: <FaStore />,
      title: "Retailer Portal",
      description: "Self-service portal for retailers to place orders and track deliveries"
    },
    {
      icon: <FaClipboardCheck />,
      title: "Order Automation",
      description: "Automated order processing and fulfillment to reduce manual work"
    }
  ];

  return (
    <section className="features" id="features">
      <div className="container">
        <SectionTitle 
          title="Powerful Features for FMCG Distribution"
          subtitle="Everything you need to manage and grow your distribution business"
        />
        <div className="features-grid">
          {features.map((feature, index) => (
            <FeatureCard 
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;